import React, { useEffect, useState } from 'react';
import axios from 'axios';

const ClearCache = () => {
  const [response, setResponse] = useState(null); // Holds JSON response
  const [error, setError] = useState(null); // Holds any errors

//   const baseURL = 'http://backend.localhost'; // Replace with your backend URL
  const baseURL = 'https://api.antiquewhiteart.com';

  useEffect(() => {
    const folderId = window.location.pathname.split('/')[1]; // Extract folderId from the path

    if (!folderId) {
      setError('Invalid folder ID.');
      return;
    }

    axios
      .get(`${baseURL}/files/clear/${folderId}`)
      .then((res) => {
        setResponse(res.data);
      })
      .catch((err) => {
        const errorMsg =
          err.response?.data?.message || 'Error clearing cache.';
        setError(errorMsg);
      });
  }, []);

  // Send JSON response as raw output
  if (response) {
    return (
      <pre >{(response.message)}</pre>
    );
  }

  if (error) {
    return (
      <pre >{(error)}</pre>
    );
  }

  // Return nothing while the API call is in progress
  return null;
};

export default ClearCache;
